import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
// import Ads from "components/ad/index.js";
// import Link from "next/link";
import { FormattedMessage } from "react-intl";
import { getLanguage } from "localization/i8intl";
import Head from "next/head";
import { NextSeo } from "next-seo";
import {metaTags} from "../../../constants/metaTags";
import { useWindowSize } from "api/commonConstants";

const CorrectionPolicy = () => {
  const [language, setLanguage] = useState("");
  const size = useWindowSize();
  const [firstScroll, setFirstScroll] = useState(false);

  useEffect(() => {
    setLanguage(getLanguage());

  async function onFirstScroll() {
    if(!firstScroll){
    setFirstScroll(true);
    setTimeout(()=>{
      window.googletag = window.googletag || {cmd: []};
      googletag.cmd.push(function() {
     
      googletag.defineSlot('/1007232/Lallantop_Desktop_ROS_ATF_728x90', [[728, 90], [970, 250], [970, 90]], 'div-gpt-ad-1701945163318-0').addService(googletag.pubads());
      googletag.defineSlot('/1007232/Lallantop_Desktop_ROS_MTF_1_728x90', [728, 90], 'div-gpt-ad-1701945220410-1').addService(googletag.pubads());
      googletag.defineSlot('/1007232/Lallantop_Mobile_ROS_ATF_300x250', [[336, 280], [300, 250]], 'div-gpt-ad-1701946028239-0').addService(googletag.pubads());
      googletag.defineSlot('/1007232/Lallantop_Mobile_ROS_MTF_1_300x250', [[336, 280], [300, 250]], 'div-gpt-ad-1701946028239-1').addService(googletag.pubads());
      googletag.pubads().enableSingleRequest();
      googletag.pubads().setTargeting('Category', ['']);
      googletag.pubads().setTargeting('Keywords', '');
      googletag.enableServices();
  });
  // apstag.init({
  //   pubID: '7f0bbd82-5a13-48ec-9950-fcb028b1546c',
  //   adServer: 'googletag',
  //   bidTimeout: 2e3
  // });
  // // request the bids for the four googletag slots
  // apstag.fetchBids({
  //   slots: [
  // ]
  // }, function(bids) {
  //   // set apstag bids, then trigger the first request to GAM
  //   googletag.cmd.push(function() {
  //     apstag.setDisplayBids();
  //     googletag.pubads().refresh();    
  //   });
  // });
  googletag.pubads().refresh();

    })}}
  function handleScroll() {
    onFirstScroll();
    window.removeEventListener("scroll", handleScroll);
  }

  window.addEventListener("scroll", handleScroll);

  }, []);
  const cateogry = "factcheck";
  const key = "FactCheck,TheLallantop";
  return (
    <>
    <Head>
    {/* <script
          dangerouslySetInnerHTML={{
            __html: `
window.googletag = window.googletag || {cmd: []};
googletag.cmd.push(function() {
  var mapping = googletag.sizeMapping().
				addSize([4000, 0], [[728, 90], [970, 90], [970, 250]]).
				addSize([3000, 0], [[728, 90], [970, 90], [970, 250]]).
				addSize([2000, 0], [[728, 90], [970, 90], [970, 250]]).
				addSize([1000, 0], [[728, 90], [970, 90], [970, 250]]).
				addSize([750, 0], [728, 90]).
				addSize([700, 0], [[300, 250],[336, 280]]).
				addSize([530, 0], [[300, 250],[336, 280]]).
				addSize([336, 0], [[300, 250],[336, 280]]).
				addSize([320, 0], [300, 250]).
				addSize([0, 0], [300, 250]).build();
	var mapping1 = googletag.sizeMapping().
				addSize([4000, 0], [728, 90]).
				addSize([3000, 0], [728, 90]).
				addSize([2000, 0], [728, 90]).
				addSize([1000, 0], [728, 90]).
				addSize([750, 0], [728, 90]).
				addSize([700, 0], [[300, 250],[336, 280]]).
				addSize([530, 0], [[300, 250],[336, 280]]).
				addSize([336, 0], [[300, 250],[336, 280]]).
				addSize([320, 0], [300, 250]).
				addSize([0, 0], [300, 250]).build();
	var mapping2 = googletag.sizeMapping().
				addSize([4000, 0], [728, 90]).
				addSize([3000, 0], [728, 90]).
				addSize([2000, 0], [728, 90]).
				addSize([1000, 0], [728, 90]).
				addSize([750, 0], [728, 90]).
				addSize([700, 0], [[300, 250],[300, 100],[320, 100]]).
				addSize([530, 0], [[300, 250],[300, 100],[320, 100]]).
				addSize([336, 0], [[300, 250],[300, 100],[320, 100]]).
				addSize([320, 0], [300, 250]).
				addSize([0, 0], [300, 250]).build();
var REFRESH_KEY = 'refresh';
var REFRESH_VALUE = 'true';
googletag.pubads().setTargeting('Category', ['']);
googletag.pubads().setTargeting('Keywords', '');
var SECONDS_TO_WAIT_AFTER_VIEWABILITY = 30;
googletag.pubads().addEventListener('impressionViewable', function(event) {
var slot = event.slot;
if (slot.getTargeting(REFRESH_KEY).indexOf(REFRESH_VALUE) > -1) {
setTimeout(function() {
googletag.pubads().refresh([slot]);
}, SECONDS_TO_WAIT_AFTER_VIEWABILITY * 1000);
}
});
    googletag.pubads().enableSingleRequest();
    googletag.enableServices();
  });`,
          }}
        ></script>

        <script
          type="text/javascript"
          dangerouslySetInnerHTML={{
            __html: `
  apstag.init({
    pubID: '7f0bbd82-5a13-48ec-9950-fcb028b1546c',
    adServer: 'googletag',
    bidTimeout: 2e3
  });
  // request the bids for the four googletag slots

  }, function(bids) {
    // set apstag bids, then trigger the first request to GAM
    googletag.cmd.push(function() {
      apstag.setDisplayBids();
      googletag.pubads().refresh();    
    });
  });`,
          }}
        ></script> */}
    </Head>
    <NextSeo
        title={metaTags["factcheck"]["correctionPolicy"].metaTitle}
        description={metaTags["factcheck"]["correctionPolicy"].metaDescription}

       />
      <div className="content-wrapper">
      <Container align="center">
          {/* <Ads adName={"/1007232/Lallantop_ROS_728x90_300x250"} /> */}
          <div className="container-row py-2" align="center">
            <p
              style={{
                fontSize: "11px",
                color: "#b7b7b7",
                textAlign: "center",
              }}
            >
              Advertisement
            </p>
            <div
              id={size.width > 600 ? "div-gpt-ad-1701945163318-0" : "div-gpt-ad-1701946028239-0"}
              style={{
                minWidth: "300px",
                minHeight: size.width > 600 ? "100px" : "260px",
                display: "block !important",
                alignContent:"center",textAlign:"-webkit-center"
              }}
            >
              <script
                type="text/javascript"
                dangerouslySetInnerHTML={{
                  __html: size.width > 600 ? `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1686741281219-0')})` : `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-0')})` ,
                }}
              ></script>
            </div>
          </div>
        </Container>
        <div className="outer-container-info-page">
          <div className="backlink-bar terms-title">
            <a href="/all/factcheck">
              <a
              // onClick={() => {
              //   ClevertapReact.event("header_back_click");
              //   router.back();
              // }}
              >
                <i className="icon-back-arrow"></i>
              </a>
            </a>
            <h2>
              <FormattedMessage id="fact_check" defaultMessage="पड़ताल" />
            </h2>
          </div>
          <h2>{language == "hi" ? "भूल सुधार" : "Correction Policy"}</h2>
          <p>
            पड़ताल लिखते वक्त हमारी कोशिश रहती है कि मामूली ग़लती भी रिपोर्ट में
            न जाए. अगर इसके बावजूद कोई मानवीय भूल हो जाती है, तो उसे हम खुले मन
            से स्वीकार करते हैं और तत्काल सुधारते हैं. जिस भी रिपोर्ट में ऐसा
            सुधार किया जाता है, उसके आखिर में इसकी जानकारी दी जाती है. अगर कोई
            बड़ी तथ्यात्मक ग़लती हो या ऐसी ग़लती कि हमें फैक्ट चेक का निष्कर्ष
            ही बदलना पड़े, तो हम रिपोर्ट की शुरुआत में प्रमुखता से इसे दिखाते
            हैं. हालांकि, वर्तनी की मामूली अशुद्धियां सुधारने पर हम आर्टिकल में
            अपड़ेट नहीं जोड़ते. अगर आप हमारे पड़ताल के तरीके या नतीजे से असहमत
            हैं, तो हमें मेल करें padtaal@lallantop.com पर. हम आपकी असहमति या
            शिकायत का संज्ञान ज़रूर लेंगे. नियमित फीडबैक के लिए आप पड़ताल के
            सोशल मीडिया हैंडल्स का इस्तेमाल कर सकते हैं.
          </p>
        </div>
        <Container align="center">
          {/* <Ads adName={"/1007232/Lallantop_ROS_728x90_300x250"} /> */}
          <div className="container-row py-2" align="center">
            <p
              style={{
                fontSize: "11px",
                color: "#b7b7b7",
                textAlign: "center",
              }}
            >
              Advertisement
            </p>
            <div
              id={size.width > 600 ? "div-gpt-ad-1701945220410-1" : "div-gpt-ad-1701946028239-1"}
              style={{
                minWidth: "300px",
                minHeight: size.width > 600 ?  "100px" : "260px",
                display: "block !important",
                alignContent:"center",textAlign:"-webkit-center"
              }}
            >
              <script
                type="text/javascript"
                dangerouslySetInnerHTML={{
                  __html: size.width > 600 ? `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945220410-1')})` :  `{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-1')})`,
                }}
              ></script>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default CorrectionPolicy;
